import { fontWeight, variants } from './typography';
import colors from './colors';

const theme = {
  colors,
  screenSize: {
    mobileS: '480px',
  },
  text: {
    fontWeight,
    variants,
  },
};

export default theme;
